import * as common from '@/store/common/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const STATE_CLEAR = 'STATE_CLEAR';
export const SELECTED_ROW = 'SELECTED_ROW';
export const MASTER_INFO = 'MASTER_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const GROUPS = `GROUPS`;

export default {
	...common,
	SEARCH_PARAM,
	SELECTED_ROW,
	MASTER_INFO,
	STATE_INIT,
	STATE_CLEAR,
	DEFAULT_ASSIGN,
	GROUPS
};
